export const applicationTitle = 'ZoukUnite';
export { default as artistTypes } from './artist-types';
export { default as genders } from './genders';
export { default as routes } from './routes';
export * from './routes';
export { default as socials } from './socials';



// WEBPACK FOOTER //
// ./src/constants/index.js